export type ChannelCodeType = {
  id: string
  code: string
  name: string
  type: ChannelType
  suggestSegmentId: string | undefined
  suggestSegmentName: string | undefined
}

// Setting default items
export const ChannelType = {
  Custom: 0, // unspecified
  Default: 1, // Default
} as const
type ChannelType = (typeof ChannelType)[keyof typeof ChannelType]
